import React from 'react';

import './loader.css';

export default (props)=>{
    return (
        <div className={`loader${props.type ? `-${props.type}` : ''}`} style={{width:props.size,height:props.size}}/>
    )
}


// WEBPACK FOOTER //
// ./src/components/Loader/index.js